import { Button } from '@adobe/react-spectrum';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import '../../styles/components/error.css';
import { getAppURIPath } from '../../utils/constants';
import { FormattedMessage } from 'react-intl';

const Error = ({
    icon,
    title,
    descPrimary,
    descSecondary,
    refresh = false,
    children,
}: {
    icon: React.ReactNode;
    title: string;
    descPrimary: string;
    descSecondary?: string;
    refresh?: boolean;
    children?: React.ReactNode;
}) => {
    const navigate = useNavigate();

    const handleRefresh = () => {
        navigate(getAppURIPath('dashboard'));
    };

    return (
        <div className="error-wrapper">
            {icon}
            <span className="error-title">{title}</span>
            <span className="error-desc">{descPrimary}</span>
            {descSecondary && <span className="error-desc">{descSecondary}</span>}
            <div className="error-content-wrapper">
                {refresh && (
                    <Button variant="secondary" onPress={() => handleRefresh()}>
                        <FormattedMessage id="lcp.common.refresh" />
                    </Button>
                )}
                {children && children}
            </div>
        </div>
    );
};

export default Error;
